import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import LspCustomerReturnProcessActions from '../../Stores/LspCustomerReturnProcess/Actions';

import LspSlsRtnExcel01Form from '../LspSlsRtnExcel01/LspSlsRtnExcel01Form';
import InbOrd04Table from '../InbOrd04/InbOrd04Table';

const { TabPane } = Tabs;

class LspCustomerReturnProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curDivisionId, fetchLspCustomerReturnProcess } = this.props;

    if (curDivisionId > 0) {
      fetchLspCustomerReturnProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curDivisionId, fetchLspCustomerReturnProcess } = this.props;
    const { changed } = treeChanges(prevProps, this.props);
    if (changed('curDivisionId')) {
      if (curDivisionId > 0) {
        fetchLspCustomerReturnProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/lspCustomerReturnProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'LSP_SLS_RTN_EXCEL_01' && (
          <LspSlsRtnExcel01Form match={match} />
        )}
        {match.params.proc_type === 'INB_ORD_04' && <InbOrd04Table match={match} />}
      </Card>
    );
  }
}

LspCustomerReturnProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curDivisionId: PropTypes.number,
  fetchLspCustomerReturnProcess: PropTypes.func
};

LspCustomerReturnProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curDivisionId: 0,
  fetchLspCustomerReturnProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.lspCustomerReturnProcess.process,
  processIsLoading: state.lspCustomerReturnProcess.processIsLoading,

  curDivisionId: state.app.curDivisionId
});

const mapDispatchToProps = dispatch => ({
  fetchLspCustomerReturnProcess: () =>
    dispatch(
      LspCustomerReturnProcessActions.lspCustomerReturnProcessFetchLspCustomerReturnProcess()
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LspCustomerReturnProcessScreen));
